import {useIntl} from 'react-intl';
import {Flex, Text, Center} from '@chakra-ui/layout';

import {useTranslate} from '@eksab/i18n';
import {Loader} from '@eksab/components/Loader';

import {useCurrentCompetitorsQuery} from '@eksab/features/trivia/hooks/useCurrentCompetitorsQuery';
import {UsersIcon} from '@eksab/features/trivia/icons/UsersIcon';

interface CurrentCompetitorsProps {
  challengeID: string;
}

export function CurrentCompetitors({challengeID}: CurrentCompetitorsProps) {
  const format = useIntl().formatNumber;

  const t = useTranslate();
  const currentCompetitorsQuery = useCurrentCompetitorsQuery(challengeID);

  return (
    <Flex gap="2" align="center" borderWidth="1px" borderColor=" #1ba482" color="#2a2e3a" p="1" ps="3" rounded="3xl">
      <Center boxSize="6" bg="radial-gradient(50% 50%, rgba(57, 226, 63, 0.76), rgba(57, 226, 63, 0.05))">
        <Flex rounded="full" bg="#39E23F" boxSize="2.5" />
      </Center>

      <Text fontSize="sm" fontWeight="700" color="inherit">
        {t('trivia.join.current-competitors')}
      </Text>

      <Flex gap="2" align="center" bg="#e9fff4" px="4" py="1" fontSize="lg" fontWeight="800" rounded="2rem" minH="9">
        <UsersIcon />

        {currentCompetitorsQuery.isSuccess ? format(currentCompetitorsQuery.data) : <Loader size="sm" />}
      </Flex>
    </Flex>
  );
}
